var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasChilds)?_c('div',{staticClass:"w-childs"},[_vm._l((_vm.childItems),function(item){return _c('Webjet',{key:item.$path,attrs:{"src":item.$path}})}),(_vm.isNestedLoop)?_c('div',{staticClass:"nested-loop"}):_vm._e()],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }